import React, { useState, useEffect } from 'react';
import ChartDonut, { Props as ChartDonutProps } from "../Donut";
import HHTextToggle from '../../../components/Form/HHTextToggle';
import ChartBar from '../Bar';

interface DonutDetailedProps extends ChartDonutProps {
  title?: string;
  formatData?: boolean;
  dashboardLength?: any;
  onClick?: Function,
  detailed: boolean;
}

type DataType = { value: number; name: string, local?: string, types?: string[] };

function processDonutData(input: DataType[]): DataType[] {
  const sortedInput = [...input].sort((a, b) => b.value - a.value);
  const totalValue = sortedInput.reduce((sum, item) => sum + item.value, 0);
  const onePercent = totalValue * 0.01;
  const overOnePercent: DataType[] = [];
  let othersValue = 0;

  for (const item of sortedInput) {
    if (item.value > onePercent) {
      let _item = {
        ...item,
        type: item.name
      }

      overOnePercent.push(_item);
    }
    // else {
    //   othersValue += item.value;
    // }

    if (overOnePercent.length === 4) {
      break;
    }
  }

  var typesList: string[] = [];

  for (let i = overOnePercent.length; i < sortedInput.length; i++) {
    othersValue += sortedInput[i].value;
    typesList.push(sortedInput[i].name);
  }

  if (othersValue > 0) {
    const localList = overOnePercent.filter(x => x.local);
    const _local = (localList.length > 0) ? localList[0].local : undefined;
    overOnePercent.push({ value: othersValue, name: "Outros", local: _local, types: typesList });
  }

  return overOnePercent;
}

const DonutDetailed: React.FC<DonutDetailedProps> = ({ formatData, title, data, dashboardLength, onClick, detailed, ...restProps }) => {
  const [toggleValue, setToggleValue] = useState('value');
  const [dataList, setDataList] = useState<any[]>([]);

  const percentValue = (value: number, toggle: string) => {
    if (toggle === 'percent') {
      const _dashboardLength = parseFloat(dashboardLength.replace(".", ""));
      return `${((value / _dashboardLength) * 100).toFixed(1)}%`
    }

    // const _value = (value.toString().length > 10 && detailed)
    //   ? value.toString().slice(0, 10) + "..."
    //   : value.toString();

    return value;
  }

  useEffect(() => {
    if (data.length > 0) {
      let resultList: any[] = [];

      if (formatData) {
        resultList = processDonutData(data);
      }

      const resultList2 = resultList.map(x => {
        return {
          ...x,
          name: (x.name.length > 10 && !detailed)
            ? x.name.slice(0, 10) + "..."
            : (x.name.length > 30 && detailed) 
              ? x.name.slice(0, 30) + "..."
              : x.name
        }
      })

      setDataList(resultList2);
    }
  }, [data, detailed]) // toggleValue

  const columns = {
    left: { label: "123", value: "value" },
    right: { label: "%", value: "percent" }
  }

  const handleClick = (item) => {
    onClick && onClick(item);
  }

  const colors = [
    "#5969CD", "#E273C5", "#804E3B", "#A5Bf3E", "#307422", "#F3C944", "#59BAC5",
    "#D5672F", "#8684EF", "#169D36", "#E74A67", "#C23D4F", "#D7BA45", "#B24F5D"
  ];

  var options: echarts.EChartsOption = {
    tooltip: {
      trigger: 'item'
    },
    series: [
      {
        type: 'pie',
        radius: ['50%', '90%'],
        avoidLabelOverlap: false,
        startAngle: 90,
        // silent: true,
        itemStyle: {
          borderRadius: 4,
          borderColor: '#fff',
          borderWidth: 4
        },
        label: {
          show: false,
        },
        labelLine: {
          show: false
        },
        data: dataList.map((d, i) => {
          return {
            ...d, itemStyle: {
              color: colors[i]
            }
          }
        })
      }
    ]
  }

  const LegendFormatter = (name) => {
    const valor = dataList.find(x => x.name === name).value;
    return `${name} (${percentValue(valor, toggleValue)})`;
  }

  // const options2: echarts.EChartsOption = {
  //   tooltip: {
  //     trigger: 'item'
  //   },
  //   legend: {
  //     // top: "40%",
  //     // orient: "vertical",
  //     // left: "right",
  //     // itemGap: 3,
  //     // itemWidth: 30,
  //     // formatter: LegendFormatter,
  //     // textStyle: {
  //     //   fontWeight: "bold"
  //     // }


  //     top: "middle",
  //     orient: "vertical",
  //     right: '0%',
  //     itemGap: 3,
  //     itemWidth: 30,
  //     formatter: LegendFormatter,
  //     // textStyle: {
  //     //   fontWeight: "bold"
  //     // }


  //     // type: 'scroll',  // Enable scroll (pagination)
  //     // orient: 'vertical',
  //     // right: '5%',
  //     // top: 'middle',
  //     // textStyle: {
  //     //     fontSize: 10
  //     // },
  //     // pageButtonItemGap: 5,
  //     // pageButtonGap: 10,
  //     // pageButtonPosition: 'end',
  //     // pageFormatter: '{current}/{total}',  // You can customize this
  //     // pageIcons: {
  //     //     horizontal: [
  //     //         'M0,0 L12,-12',    // up
  //     //         'M0,12 L12,0'     // down
  //     //     ]
  //     // },
  //     // data: dataList.map(x => x.name),
  //     // formatter: function (name) {
  //     //     if (name.length > 25) {
  //     //         return name;
  //     //     } else {
  //     //         return name;
  //     //     }
  //     // }



  //   },
  //   series: [
  //     {
  //       type: 'pie',
  //       radius: ['50%', '70%'],
  //       center: ['30%', '50%'],
  //       avoidLabelOverlap: false,
  //       startAngle: 90,
  //       itemStyle: {
  //         borderRadius: ["2%", "2%", "2%", "2%"],
  //         borderColor: '#fff',
  //         borderWidth: 1
  //       },
  //       labelLine: {
  //         show: false
  //       },

  //       // data: [
  //       //   { value: 1048, name: 'Search Engine', label: { show: false } },
  //       //   { value: 735, name: 'Direct', label: { show: false } },
  //       //   { value: 580, name: 'Email', label: { show: false } },
  //       //   { value: 484, name: 'Union Ads', label: { show: false } },
  //       //   { value: 300, name: 'Video Ads', label: { show: false } },
  //       // ]

  //       data: dataList.map((d, i) => {
  //         return {
  //           ...d,
  //           label: { show: false }
  //         }
  //       })

  //     }
  //   ],
  //   emphasis: {
  //     label: {
  //       show: false
  //     }
  //   }
  // };

  return (
    <div
      className={`chartbox ${(detailed) ? "wDash49p" : "wDash32p"} boxShadowLightBlack`}
      style={{
        height: "100%",
        marginRight: "0px"
      }}
    >
      <div className='row start'
        style={{
          paddingLeft: '16px',
          paddingTop: '6px',
          color: '#8B90A3',
          fontSize: '16px',
          justifyContent: 'space-between',
        }}
      >
        <span>{title}</span>
        <HHTextToggle
          onChange={event => setToggleValue(event.target.value)}
          options={columns}
          value={toggleValue}
        />
      </div>
      {/* <ChartBar options={options2} /> */}

      <ChartDonut
        data={dataList}
        renderValue={(e) => percentValue(e, toggleValue)}
        onClick={handleClick}
        styleLegend={{ paddingLeft: (!detailed) ? '7px' : undefined, height: "40%" }}
        styleChart={{ height: (!detailed) ? "100%" : "12rem" }}
        options={options}
        colors={colors}
        legendBadgeSmall={true}
        styleGeral={{
          height: "100%",
          display: 'flex',
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-around'
        }}
      />
    </div>
  );
}

export default DonutDetailed;